export interface User {
    userId: number;
    photo?: string;
    name?: string;
    age?: number;
    city?: string;
}

export const defaultUser: User = { userId: null, photo: null, name: null, age: null, city: null };